import { LedContent, LedTheme } from 'containers/led/layouts';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import LedServerError from 'containers/led/layouts/LedServerError';
import { NextRouter, useRouter } from 'next/router';
import ledStores from 'stores/led';
import { LedProgressSpinner } from 'components/led/atoms';

interface LedLayoutProps {
  children: ReactNode;
}

const LedLayout: FC<LedLayoutProps> = ({ children }) => {
  const { ledLayoutStore } = ledStores;
  const { isValidSession } = ledLayoutStore;
  const { push, pathname }: NextRouter = useRouter();
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (!isValidSession(pathname)) {
      (async () => {
        await push(ledLayoutStore.lastUserStep);
      })();
    } else {
      setIsValid(true);
    }
  }, [pathname]);

  if (!isValid) {
    children = <LedProgressSpinner />;
  }

  return (
    <LedTheme>
      <LedContent>{children}</LedContent>
      <LedServerError />
    </LedTheme>
  );
};

export default LedLayout;
